import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Config";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

/*
 * Printable fuel and maintenance log, carrying whatever filter the screen had.
 */
function PrintVehicleLog() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const MemberType = localStorage.getItem("MemberType");

  const urlParams = new URLSearchParams(window.location.search);
  const vehicle = urlParams.get("vehicle") || "";
  const month = urlParams.get("month") || "";

  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    document.title = "Fuel & Maintenance Log";

    const range = month
      ? {
          From_Date: moment(month, "YYYY-MM").startOf("month").format("YYYY-MM-DD"),
          To_Date: moment(month, "YYYY-MM").endOf("month").format("YYYY-MM-DD"),
        }
      : { From_Date: null, To_Date: null };

    axios({
      method: "post",
      url: config.base_url + "VehicleLog/GetLogs",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType: MemberType || "Admin",
        SchoolID: 1,
        Vehicle_ID: vehicle ? parseInt(vehicle, 10) : 0,
        ...range,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setLogs(res.data.ListofRecords || []);
          setSummary(res.data.Summary || null);
        }
      })
      .catch(() => setLogs([]))
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, MemberType, vehicle, month]);

  const money = (n) =>
    n === null || n === undefined || n === 0
      ? "-"
      : Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });

  return (
    <>
      {loading ? (
        <div className="text-center p-5">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <Page orientation="landscape" size="A4">
          <PrintHeader title="Fuel & Maintenance Log" />

          <div style={{ fontSize: "10pt", marginBottom: "8px" }}>
            <b>Period:</b> {month ? moment(month, "YYYY-MM").format("MMMM YYYY") : "All dates"}
            {summary ? (
              <>
                {"   |   "}
                <b>Entries:</b> {summary.Entries}
                {"   |   "}
                <b>Fuel:</b> {money(summary.FuelQuantity)} Ltr / Rs. {money(summary.FuelCost)}
                {"   |   "}
                <b>Maintenance:</b> Rs. {money(summary.MaintenanceCost)}
                {"   |   "}
                <b>Total:</b> Rs. {money(summary.TotalCost)}
                {summary.AvgKmPerLitre ? (
                  <>
                    {"   |   "}
                    <b>Mileage:</b> {summary.AvgKmPerLitre} km/L
                  </>
                ) : null}
              </>
            ) : null}
          </div>

          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Sr.</th>
                <th>Date</th>
                <th>Bus</th>
                <th style={{ textAlign: "right" }}>Litres</th>
                <th style={{ textAlign: "right" }}>Rate</th>
                <th style={{ textAlign: "right" }}>Odometer</th>
                <th style={{ textAlign: "right" }}>Distance</th>
                <th style={{ textAlign: "right" }}>Km/L</th>
                <th>Maintenance</th>
                <th style={{ textAlign: "right" }}>Fuel cost</th>
                <th style={{ textAlign: "right" }}>Maint. cost</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    No entries for this selection
                  </td>
                </tr>
              ) : (
                logs.map((r, i) => (
                  <tr key={r.ID}>
                    <td>{i + 1}</td>
                    <td>{moment(r.Log_Date).format("DD-MMM-YYYY")}</td>
                    <td style={{ fontWeight: 600 }}>{r.Registration_No}</td>
                    <td style={{ textAlign: "right" }}>
                      {r.Fuel_Quantity > 0 ? r.Fuel_Quantity : "-"}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {r.Fuel_Rate ? Number(r.Fuel_Rate).toFixed(2) : "-"}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {r.Odometer_Reading ? money(r.Odometer_Reading) : "-"}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {r.Distance_KM ? money(r.Distance_KM) : "-"}
                    </td>
                    <td style={{ textAlign: "right" }}>{r.KmPerLitre || "-"}</td>
                    <td>{r.Maintenance_Type || "-"}</td>
                    <td style={{ textAlign: "right" }}>{money(r.Fuel_Cost)}</td>
                    <td style={{ textAlign: "right" }}>{money(r.Maintenance_Cost)}</td>
                  </tr>
                ))
              )}
            </tbody>
            {logs.length > 0 && summary ? (
              <tfoot>
                <tr style={{ fontWeight: 700 }}>
                  <td colSpan="9" style={{ textAlign: "right" }}>
                    TOTALS
                  </td>
                  <td style={{ textAlign: "right" }}>{money(summary.FuelCost)}</td>
                  <td style={{ textAlign: "right" }}>{money(summary.MaintenanceCost)}</td>
                </tr>
              </tfoot>
            ) : null}
          </table>
        </Page>
      )}
    </>
  );
}

export default PrintVehicleLog;
